import {
  Card,
  CardContent,
  Chip,
  LinearProgress,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@material-ui/core';
import React, { useState } from 'react';
import { useUsers } from '../../../common/CommonQueries';
import { Autocomplete } from '@material-ui/lab';

export const TaggedPM = ({ projectManagers, setprojectManagers, isNew }: any) => {

  const { data: users, isLoading: isLoadingUsers } = useUsers();

  const [taggedPM, setTaggedPM] = useState<any[]>([]);








  const handleAdd = (event: any) => {
    const selectedUserId = event.target.value;
    const selectedUser = users?.find((user: any) => user.id === selectedUserId);

    if (selectedUser && setprojectManagers) {

      if (!projectManagers.some((u: any) => u.id === selectedUser.id)) {
        const updated = [...projectManagers, selectedUser];
        setprojectManagers(updated);
      }
    }
  };


  const handleDelete = (event: any) => {
    if (setprojectManagers !== undefined) {
      setprojectManagers((projectManagers: any) =>
        projectManagers.filter((user: any) => user.id !== event.id)
      );
    }
  };
  React.useEffect(() => {
    if (users && projectManagers.length !== 0) {
      let array = users;
      projectManagers.map((tUser: any) => {
        array = (array.filter((user: any) => user.id !== tUser.id))
      })
      setTaggedPM(array);
    } else if (users && projectManagers.length === 0) {
      setTaggedPM(users);
    }
  }, [users, projectManagers]);




  if (isLoadingUsers) {
    return (
      <>
        <Card style={{ marginTop: 12 }}>
          <CardContent>
            <Typography variant="h6">Tagged Project Managers:</Typography>
            <LinearProgress />
          </CardContent>
        </Card>
      </>
    );
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">Tagged PM:</Typography>

        {/* <Select
          id="tagged-pm"
          name="tagged-pm"
          onChange={handleAdd}
          label="Tagged PM"
          fullWidth
          displayEmpty
          value=""
        >
          <MenuItem value="" disabled>
            Select a PM
          </MenuItem>
          {taggedPM?.map((user: any) => (
            <MenuItem key={user.id} value={user.id}>
              {user.username}
            </MenuItem>
          ))}
        </Select> */}
        <Autocomplete
          options={taggedPM || []}
          getOptionLabel={(option: any) => option.username}
         
          onChange={(event, value) => {
            if (value) {
              handleAdd({ target: { value: value.id } }); 
              
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select a PM"
              variant="standard"
              fullWidth
            />
          )}
        />
        <div style={{ marginTop: '1rem' }}>
          {projectManagers?.map((user: any) => (
            <Chip
              key={user.id}
              label={user.username}
              onDelete={() => handleDelete(user)}
              style={{ marginRight: 8, marginBottom: 8 }}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
